import React from 'react';
import { linearScale } from './functions/LinearScale';
import styles from './css/fillStyle.module.css';

const DEFAULT_EPOCH_DURATION_SECONDS = 30; // 預設的 epoch 持續時間 (秒)

const fixedLinesData = {
  mslt: [
    { index: 0.05, label: 'Light Off', epoch: 45 - 1 },
    { index: 0.033, label: 'Light On', epoch: 85 - 1 },
    { index: 0.05, label: 'Light Off', epoch: 285 - 1 },
    { index: 0.033, label: 'Light On', epoch: 325 - 1 },
    { index: 0.05, label: 'Light Off', epoch: 529 - 1 },
    { index: 0.033, label: 'Light On', epoch: 569 - 1 },
    { index: 0.05, label: 'Light Off', epoch: 767 - 1 },
    { index: 0.033, label: 'Light On', epoch: 807 - 1 },
    { index: 0.05, label: 'Light Off', epoch: 1009 - 1 },
    { index: 0.033, label: 'Light On', epoch: 1049 - 1 },
  ],
  psg_0307: [
    { index: 0.05, label: 'Light Off', epoch: 1 - 1 },
    // { index: 0.55, label: 'snore(+)', epoch: 100 - 1 },
    // { index: 0.634, label: 'snore(+)', epoch: 166 - 1 },
    // { index: 0.35, label: 'snore(-)', epoch: 291 - 1 },
    // { index: 0.62, label: 'snore(-)', epoch: 345 - 1 },
    // { index: 0.38, label: 'snore(-)', epoch: 391 - 1 },
    // { index: 0.8, label: 'W', epoch: 472 - 1 },
    // { index: 0.6, label: 'snore(+)', epoch: 526 - 1 },
    // { index: 0.333, label: 'snore(-)', epoch: 585 - 1 },
    // { index: 0.234, label: '廁所', epoch: 620 - 1 },
    // { index: 0.7, label: 'snore(+)', epoch: 706 - 1 },
    // { index: 0.72, label: 'snore(-)', epoch: 750 - 1 },
    // { index: 0.135, label: 'snore(+)', epoch: 812 - 1 },
    // { index: 0.47, label: '廁所', epoch: 921 - 1 },
    { index: 0.833, label: 'Light On', epoch: 915 - 1 },
  ],
  workshop_2026: [
    { index: 0.001, label: 'Analysis Start', epoch: 26 - 1 },
  ]
};

function CursorLineLayer(props) {
  // 用於將比例值轉換為 X 軸螢幕座標的函數
  const transform = linearScale(0, 1, props.leftBoundary, props.rightBoundary);
  // 計算動態游標紅線的 X 座標
  const x = transform(props.proportion);

  // 檢查計算出的 x 是否為有效數字
  const showCursorLine = typeof x === 'number' && !isNaN(x) &&
    typeof props.bottomBoundary === 'number' && !isNaN(props.bottomBoundary) &&
    typeof props.topBoundary === 'number' && !isNaN(props.topBoundary);

  // 檢查繪製固定標線所需的核心 props 是否存在且有效
  const canRenderFixedLines = props.psgFileId &&
    typeof props.viewStartTimeSeconds === 'number' && !isNaN(props.viewStartTimeSeconds) &&
    typeof props.viewDurationSeconds === 'number' && !isNaN(props.viewDurationSeconds) && props.viewDurationSeconds > 0;

  return (
    <svg width={props.width} height={props.height} className={styles.fill}>
      {/*動態紅色游標線*/}
      {showCursorLine && (
        <line
          x1={x}
          x2={x}
          y1={props.bottomBoundary}
          y2={props.topBoundary}
          className={styles.redLine} // 紅線的樣式
        />
      )}

      {/* 條件性地渲染固定的事件標線 */}
      {canRenderFixedLines && (() => {
        // 根據 psgFileId 選擇要使用的標線資料
        let selectedRawLines = [];
        if (props.psgFileId == 11) {
          selectedRawLines = fixedLinesData.mslt;
        } else if (props.psgFileId == 10) {
          selectedRawLines = fixedLinesData.psg_0307;
        } else if (props.psgFileId == 5) {
          selectedRawLines = fixedLinesData.workshop_2026; // 目前沒有特定資料，暫時使用 psg_0307 的資料
        }
        if (selectedRawLines.length === 0) {
          return null;
        }

        // 計算固定標線所需的時間相關變數
        const viewStartTime = props.viewStartTimeSeconds;
        const viewEndTime = props.viewStartTimeSeconds + props.viewDurationSeconds;
        const epochDuration = props.epochDurationSeconds || DEFAULT_EPOCH_DURATION_SECONDS;

        return selectedRawLines.map((line, idx) => {
          // 計算事件的絕對時間 (秒)
          const eventAbsoluteTimeSeconds =
            line.epoch * epochDuration + line.index * epochDuration;

          // 判斷事件是否在當前窗口內
          const isEventInView = eventAbsoluteTimeSeconds >= viewStartTime && eventAbsoluteTimeSeconds <= viewEndTime;

          if (isEventInView) {
            const proportionInView = (eventAbsoluteTimeSeconds - viewStartTime) / props.viewDurationSeconds;

            if (isNaN(proportionInView) || proportionInView < 0 || proportionInView > 1) {
              // console.warn(`Line ${idx} (${line.label}) has invalid proportionInView:`, proportionInView, 'Skipping render for this line.');
              return null;
            }

            const fixedX = transform(proportionInView);

            if (isNaN(fixedX)) {
              // console.warn(`Line ${idx} (${line.label}) has invalid fixedX. Skipping.`);
              return null;
            }

            // 計算文字標籤的位置和大小
            const textX = fixedX + 5;
            const textY = (props.topBoundary + props.bottomBoundary) / 2;
            const textWidth = 60;
            const textHeight = 16;

            // 根據 psgFileId 和標籤內容決定標線樣式
            let lineClassName = styles.fixedLine;
            if (props.psgFileId == 10) {
              lineClassName = line.label.includes('Light') ? styles.fixedLine : styles.logLine;
            }

            return (
              <g key={`${props.psgFileId}-${line.label}-${idx}`}>
                <line
                  x1={fixedX}
                  x2={fixedX}
                  y1={props.bottomBoundary}
                  y2={props.topBoundary}
                  className={lineClassName}
                />
                <rect
                  x={textX - 2}
                  y={textY - textHeight + 3}
                  width={textWidth}
                  height={textHeight}
                  className={styles.labelBackground}
                  rx={3}
                  ry={3}
                />
                <text x={textX} y={textY} className={styles.text}>
                  {line.label} {/* 顯示事件標籤文字 */}
                </text>
              </g>
            );
          }
          return null; // 事件不在當前視圖內
        });
      })()}
    </svg>
  );
}

// 設定預設 props
CursorLineLayer.defaultProps = {
  proportion: 0, // 游標的預設比例位置
  leftBoundary: 0,
  rightBoundary: 0,
  topBoundary: 0,
  bottomBoundary: 0,
  width: 0,
  height: 0,
  // psgFileId, viewStartTimeSeconds, viewDurationSeconds 等沒有預設值
};

export default CursorLineLayer;
